import * as React from 'react';
import FlowSegmentedControl, { SegmentItem } from 'components/FlowSegmentedControl';

export type TickerType = 'Stocks' | 'ETFs' | 'All';

interface Props {
  activeType: string;
  onChange: (next: TickerType) => void;
  className?: string;
}

// Display label → stored `tt` value. Equities are persisted as `'Stocks'` (the value the
// trade + aggregate filters compare against in useCommandCenter); we only relabel it as
// "Equities" in the UI. `'All'` means equities + ETFs together.
const TICKER_TYPES: SegmentItem[] = [
  { value: 'Stocks', label: 'Equities' },
  { value: 'ETFs', label: 'ETFs' },
  { value: 'All', label: 'All' },
];

export default function FlowTickerTypeSelector({ activeType, onChange, className }: Props) {
  return (
    <FlowSegmentedControl
      ariaLabel="Ticker type"
      tooltip="Ticker type · Equities, ETFs, or All"
      className={className}
      items={TICKER_TYPES}
      isActive={(value) => activeType === value}
      onSelect={(value) => onChange(value as TickerType)}
    />
  );
}
